/**
 * @description For multiple class names that include internal logic
 * @param  {...any} classes
 * @returns {string} Class names
 */
export const classNames = (...classes) => classes?.filter(Boolean)?.join(' ') || '';

/**
 * @description Add class name to a ref element
 * @param {Object} ref
 * @param {string} className
 * @returns {void}
 */
export const addClassNameToRef = (ref, className) => ref?.current?.classList?.add(className) || null;

/**
 * @description Remove class name to a ref element
 * @param {Object} ref
 * @param {string} classNames
 * @returns {void}
 */
export const removeClassNameToRef = (ref, className) => ref?.current?.classList?.remove(className) || null;

/**
 * @description Set attribute to a ref element
 * @param {Object} ref
 * @param {string} attribute
 * @param {string} value
 * @returns {void}
 */
export const setAttributeToRef = (ref, attribute, value) => ref?.current?.setAttribute(attribute, value) || null;
